import React, { useMemo } from 'react';

import { NewLegalDocumentTableProps } from './interface';

import Table from 'components/Table';

import { TableNewDocumentContainer } from './styles';

export const TableNewDocument: React.FC<NewLegalDocumentTableProps> = (props) => {

  const { trackingKey, data, model } = props;

  const NewLegalDocumentTableRender = useMemo(
    () => (
      <Table
        trackingKey={trackingKey}
        className="mt-1"
        data={data}
        DropdownTemplate={undefined}
        model={model}
        emptyDataMessage="Utilize o formulário acima para adicionar os documentos"
      />
    ),
    [data]
  );

  return (
    <TableNewDocumentContainer>
      {NewLegalDocumentTableRender}
    </TableNewDocumentContainer>
  );
};
